module.exports = __webpack_public_path__ + "png/logo-schaatsen@2x.png";